import { Injectable } from '@angular/core';
import anime from 'animejs';

@Injectable({
  providedIn: 'root'
})
export class AnimationService {

  constructor() { }

  initAnimations(): void {
    // Use IntersectionObserver for scroll-triggered animations
    const animeElements = document.querySelectorAll('[data-anime]');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('anime-complete')) {
          const element = entry.target;
          const animeData = element.getAttribute('data-anime');
          if (animeData) {
            try {
              const options = JSON.parse(animeData);
              this.animateElement(element, options);
              element.classList.add('anime-complete');
              observer.unobserve(element);
            } catch (e) {
              console.error('Error parsing anime data:', e);
            }
          }
        }
      });
    }, { threshold: 0.1 });

    animeElements.forEach(el => observer.observe(el));

    // Initialize counter animations
    this.initCounters();
    
    // Initialize progress bars
    this.initProgressBars();
  }

  private animateElement(element: Element, options: any): void {
    if (options.el === 'childs') {
      const children = Array.from(element.children);
      const staggerValue = options.staggervalue || 0;
      const delay = options.delay || 0;
      
      children.forEach((child: Element, index: number) => {
        const childDelay = delay + (index * staggerValue);
        anime({
          targets: child,
          translateY: options.translateY || [30, 0],
          opacity: options.opacity || [0, 1],
          duration: options.duration || 600,
          delay: childDelay,
          easing: options.easing || 'easeOutQuad'
        });
      });
    } else {
      anime({
        targets: element,
        translateX: options.translateX || undefined,
        translateY: options.translateY || undefined,
        opacity: options.opacity || undefined,
        duration: options.duration || 600,
        delay: options.delay || 0,
        easing: options.easing || 'easeOutQuad'
      });
    }
  }

  initCounters(): void {
    const counters = document.querySelectorAll('.vertical-counter, .counter');
    counters.forEach((counter: Element) => {
      const target = parseInt(counter.getAttribute('data-to') || '0');
      const text = counter.getAttribute('data-text') || '';
      
      if (target > 0) {
        anime({
          targets: counter,
          innerHTML: [0, target],
          duration: 2000,
          easing: 'easeOutExpo',
          round: 1,
          update: function(anim: any) {
            counter.innerHTML = Math.floor(anim.animatables[0].target.innerHTML) + text;
          }
        });
      }
    });
  }

  initProgressBars(): void {
    const progressBars = document.querySelectorAll('.progress-bar');
    progressBars.forEach((bar: Element) => {
      const value = parseInt(bar.getAttribute('aria-valuenow') || '0');
      if (value > 0) {
        anime({
          targets: bar,
          width: ['0%', `${value}%`],
          duration: 2000,
          easing: 'easeOutExpo'
        });
      }
    });
  }

  animateOnScroll(element: Element, options: any): void {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          anime({
            targets: entry.target,
            ...options
          });
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    observer.observe(element);
  }
}

